var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.902 27.201L3.655 2H28.345L26.095 27.197L15.985 30L5.902 27.201Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.858L24.17 25.593L26.092 4.06097H16V27.858Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.407H11.91L11.628 10.242H16V7.151H8.25L8.324 7.981L9.083 16.498H16V13.407V13.407ZM16 21.434L15.986 21.438L12.544 20.509L12.324 18.044H9.221L9.654 22.896L15.986 24.654L16 24.65V21.434Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.989 13.407V16.498H19.795L19.437 20.507L15.989 21.437V24.653L22.326 22.896L22.372 22.374L23.098 14.237L23.174 13.407H15.989V13.407ZM15.989 7.151V10.242H23.455L23.517 9.548L23.658 7.981L23.732 7.151H15.989V7.151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomHtml);
export default __webpack_public_path__ + "static/media/custom_html.a71040da21ee46cc824e73a020340ccd.svg";
export { ForwardRef as ReactComponent };